import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-linkedin",
  "use": "icon-linkedin-usage",
  "viewBox": "0 0 18.151 18.13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.151 18.13\" id=\"icon-linkedin\"><path d=\"M18.151 18.13h-3.753v-5.888c0-1.406-.032-3.214-1.956-3.214-1.956 0-2.262 1.522-2.262 3.108v5.994H6.42V6.026h3.6v1.649h.053a3.967 3.967 0 0 1 3.563-1.956c3.806 0 4.514 2.505 4.514 5.761v6.65ZM2.178 4.366a2.183 2.183 0 1 1 2.177-2.188 2.184 2.184 0 0 1-2.177 2.188ZM4.059 18.13H.296V6.026h3.763Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol